module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.ad11054.eot";